import {
  Card,
  CardActions,
  CardHeader,
  Divider,
  useTheme,
} from "@mui/material";
import { WidgetContent } from "./WidgetContent";
import { widgetStyles } from "./widgetStyles";
import { PageLayoutWidgetDto } from "../../generated/models";

export function WidgetWrapper({
  pageLayoutWidget,
  headerAction,
  children,
  cardActions,
  error = undefined,
  cardHeaderDivider = false,
  cardActionsDivider = false,
  isEmpty,
  noPadding,
  containerSizeInPixels,
  errorContactAccountTeamLink,
  hideWidgetContentOnError,
}: Readonly<{
  pageLayoutWidget: PageLayoutWidgetDto;
  headerAction?: React.ReactNode;
  children?: React.ReactNode;
  cardActions?: React.ReactNode;
  error?: boolean;
  cardHeaderDivider?: boolean;
  cardActionsDivider?: boolean;
  isEmpty?: boolean;
  noPadding?: boolean;
  containerSizeInPixels?: number;
  errorContactAccountTeamLink?: string;
  hideWidgetContentOnError?: boolean;
}>) {
  const theme = useTheme();
  const styles = widgetStyles(theme);

  return (
    <Card sx={styles.card}>
      <CardHeader
        title={
          <div role={"heading"} aria-level={2}>
            {pageLayoutWidget.title || ""}
          </div>
        }
        subheader={
          pageLayoutWidget.widgetGroup && (
            <div role={"heading"} aria-level={3}>
              {pageLayoutWidget.widgetGroup}
            </div>
          )
        }
        action={headerAction}
        sx={styles.cardHeader}
      />
      {cardHeaderDivider && <Divider />}
      <WidgetContent
        error={error}
        isEmpty={isEmpty}
        noPadding={noPadding}
        containerSizeInPixels={containerSizeInPixels}
        errorContactAccountTeamLink={errorContactAccountTeamLink}
        hideWidgetContentOnError={hideWidgetContentOnError}
      >
        {children}
      </WidgetContent>
      {cardActionsDivider && <Divider />}
      {cardActions && <CardActions>{cardActions}</CardActions>}
    </Card>
  );
}
